import React from 'react';
import type { FluidBgImageObject } from '../../../../types';
import Dual from '../../../Dual';
import { bgLayer } from '../../../lib/color';
import BackgroundImage from '../../../BackgroundImage';
import NewsFeed from './NewsFeed';

interface Props {
  items: React.ComponentProps<typeof NewsFeed>['items'];
  bgImg: FluidBgImageObject;
}

const NewsFeedBlock: React.FC<Props> = ({ bgImg, items }) => (
  <BackgroundImage
    id="NewsFeedBlock"
    as="section"
    className="pt-8 pb-6 sm:p-8 md:p-10 lg:p-12 flex flex-col items-center"
    fluid={[bgLayer([0, 0, 0], 0.8), bgImg, bgLayer(`black`)]}
  >
    <Dual.H1 className="sans-widest text-3xl font-bold mb-6 antialiased text-white text-center px-6">
      <>What&rsquo;s New</>
      <>Añadidos Recientemente</>
    </Dual.H1>
    <div className="flex self-stretch justify-center">
      <NewsFeed className="max-w-screen-lg flex-grow self-stretch" items={items} />
    </div>
  </BackgroundImage>
);

export default NewsFeedBlock;
